import 'jquery';
import { headerMobile, headerObserver } from './functions/header'
import { sliderHeroInit, sliderContentInit, sliderImagesInit, sliderTabsInit, sliderPostInit } from './functions/slider'
import { teamInit } from './functions/team'
import { infiniteScrollInit } from './functions/infiniteScroll'
import { modalInit } from './functions/modal'
import { scrollAnchors } from './functions/anchors'
import { partnerFormInit } from './functions/form'
import { parallaxInit } from './functions/parallax'

$(document).ready(() => {
  headerMobile()
  headerObserver()
  sliderHeroInit()
  sliderContentInit()
  sliderImagesInit()
  sliderTabsInit()
  sliderPostInit()
  teamInit()
  infiniteScrollInit()
  modalInit()
  scrollAnchors()
  partnerFormInit()
  parallaxInit()
});